/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Job_TrackingInputs */

const en_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job tracking`)
};

const de_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen-Tracking`)
};

const fr_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi d'emploi`)
};

const es_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento de empleo`)
};

const it_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciamento lavori`)
};

const nl_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baantracking`)
};

const pl_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledzenie ofert`)
};

const fi_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikan seuraaminen`)
};

const da_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobsporing`)
};

const sv_pricing_compare_job_tracking = /** @type {(inputs: Pricing_Compare_Job_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbspårning`)
};

/**
* | output |
* | --- |
* | "Job tracking" |
*
* @param {Pricing_Compare_Job_TrackingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_job_tracking = /** @type {((inputs?: Pricing_Compare_Job_TrackingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Job_TrackingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_compare_job_tracking(inputs)
	if (locale === "fr") return fr_pricing_compare_job_tracking(inputs)
	if (locale === "es") return es_pricing_compare_job_tracking(inputs)
	if (locale === "it") return it_pricing_compare_job_tracking(inputs)
	if (locale === "nl") return nl_pricing_compare_job_tracking(inputs)
	if (locale === "pl") return pl_pricing_compare_job_tracking(inputs)
	if (locale === "fi") return fi_pricing_compare_job_tracking(inputs)
	if (locale === "da") return da_pricing_compare_job_tracking(inputs)
	if (locale === "sv") return sv_pricing_compare_job_tracking(inputs)
	return en_pricing_compare_job_tracking(inputs)
});